import { sendMessageToFlutter } from "../bridge";
import { FlutterChannel } from "../enums/channel";

/**
 * Sends the user's language code to the Flutter wrapper.
 * Retries automatically during early boot if the Flutter JavaScript channel
 * is not yet injected on window.
 *
 * @param language - The language code (e.g. "nl" or "en")
 */
export function sendLanguageToFlutter(language?: string): void {
  const lang =
    language ||
    (typeof window !== "undefined"
      ? localStorage.getItem("locale") || "en"
      : "en");

  const payload = { language: lang };

  if (typeof window === "undefined") {
    return;
  }

  const trySend = (): boolean => {
    const channel = (window as any)[FlutterChannel.SET_LANGUAGE];
    if (channel && typeof channel.postMessage === "function") {
      sendMessageToFlutter(FlutterChannel.SET_LANGUAGE, payload);
      return true;
    }
    return false;
  };

  if (!trySend()) {
    let attempts = 0;
    const interval = setInterval(() => {
      attempts++;
      if (trySend() || attempts >= 15) {
        clearInterval(interval);
      }
    }, 200);
  }
}
